import PropTypes from 'prop-types'
import dynamic from 'next/dynamic';
import PostConstants from '../../constants/Post';

const GoogleAdSense = dynamic(() => import('../Ads/GoogleAdSense'));
const  BookListicle  = dynamic(() => import('../BookListicle/BookListicle'));

const BookInfoBatch = (props) => {
  const renderAd = () => {
    return (
      <div style={{ marginBottom: "45px" }}>
        <GoogleAdSense />
      </div>
    );
  }

  const insertInContentMobileAd = (index, key) => {
    if (props.postType === PostConstants.TYPES.DEALS || props.postType === PostConstants.TYPES.YOUNG_BOOK_READER) {
      return (
        <div key={index} className="deals-incontent-ad">
          {renderAd(`ad${index}-${key}`, "Top", false, "Middle1")}
        </div>
      );
    }
  }

  const renderBookInfoComponent = (components) => {
    return components.map((component, i) => {
      let ad = i !== 0 && i % 10 === 0 && insertInContentMobileAd(i, `batch-${i}`);
      return (
        <div className="book-info-batch" key={`book-batch-${i}`}>
          <BookListicle
            {...component.props}
            currentSiteID={props.currentSiteID}
            postType={props.postType}
          />
          {ad}
        </div>
      )
    })
  };
  return (
    <div>
      {renderBookInfoComponent(props.components)}
    </div>
  )
}

export default BookInfoBatch;

BookInfoBatch.propTypes = {
  components: PropTypes.arrayOf(PropTypes.object),
  currentSiteID: PropTypes.number,
  postType: PropTypes.number
};